export default __webpack_public_path__ + "38d4178490a600ee57d6ce1ed377b07c.otf";